<template>
  <div v-if="showModal">
    <div v-if="showMenus" class="menus">
      <div class="menu_li" v-if="!!(initData.workorderMode * 1)" @click="messageFn()">
        <span class="menu_icon">
          <span class="message"></span>
        </span>
        <span class="menu_title">{{ $t('message') }}</span>
      </div>
      <div v-if="userInfo.status === 2" class="menu_li">
        <span class="menu_icon">
          <span class="camera"></span>
        </span>
        <span class="menu_title">{{ $t('camera') }}</span>
        <input capture="camera" accept="image/*" type="file" @change='onUploadImg' className='imgUpload' />
      </div>
      <div v-if="userInfo.status === 2" class="menu_li">
        <span class="menu_icon">
          <span class="file"></span>
        </span>
        <span class="menu_title">{{ $t('file') }}</span>
        <input @change="changeFile" accept="image/png,image/jpg,image/heic,image/jpeg,video/mp4,video/mov,video/avc,video/hevc" type="file"
          ref="input_file">
      </div>
      <div v-if="!!(initData.evaluateMode * 1)" class="menu_li" @click="evaluateFn()">
        <span class="menu_icon">
          <span class="evaluate"></span>
        </span>
        <span class="menu_title">{{ $t('evaluate') }}</span>
      </div>

    </div>
    <div v-if="showEmoji" class="emoji">
      <span @click="chooseEmoji" v-for="emo in emojiList" :key="emo.id">{{ emo }}</span>
    </div>
  </div>
</template>

<script>
import language from "../../store/index";
import { Popup } from "mint-ui";
import Evaluate from "./evaluate";
import Message from "./message";
import chatApi from "../methods";
import emoji from "../../api/emoji";
import urlParams from "../../api/urlParams";

export default {
  name: "FooterMenus",
  data() {
    return {
      emojiList: emoji,
      evaluateModalFlag: "",
      messageModalFlag: "",
      popupVisibleEvaluate: false,
      popupVisibleMessage: false,
    };
  },
  components: {
    Popup,
    Evaluate,
    Message,
  },
  watch: {
    showModal() {
      return this.$store.state.configH5.showModal;
    },
    showMenus() {
      return this.$store.state.configH5.showMenus;
    },
    showEmoji() {
      return this.$store.state.configH5.showEmoji;
    },
    evaluateModal() {
      this.evaluateModalFlag = this.$store.getters.getConfigPc.evaluateModal;
    },
    messageModal() {
      this.messageModalFlag = this.$store.getters.getConfigPc.messageModal;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    initData() {
      return this.$store.state.initData;
    },
  },
  computed: {
    showModal() {
      return this.$store.state.configH5.showModal;
    },
    showMenus() {
      return this.$store.state.configH5.showMenus;
    },
    showEmoji() {
      return this.$store.state.configH5.showEmoji;
    },
    evaluateModal() {
      this.evaluateModalFlag = this.$store.getters.getConfigPc.evaluateModal;
    },
    messageModal() {
      this.messageModalFlag = this.$store.getters.getConfigPc.messageModal;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    initData() {
      return this.$store.state.initData;
    },
  },
  mounted() {
  },
  methods: {
    evaluateFn() {
      this.$store.dispatch("setConfigPc", [
        { key: "evaluateModal", value: true },
      ]);
    },
    messageFn() {
      this.$router.push({
        path: '/leaveMsgH5',
        query: {
          userId: this.$store.state.userInfo.userId || urlParams("userId"),
          tenantId: this.$store.state.initData.tenantId || urlParams("tenantId"),
          channelId: this.$store.state.initData.channelId || urlParams("channelId"),
          pid: this.$store.state.userInfo.pid || urlParams("pid"),
          userName: this.$store.state.userInfo.userName || urlParams("userName"),
          locale: urlParams("locale"),
        }
      })


    },
    //上传文件
    changeFile(file) {
      const files = file.target.files[0]; //获取文件
      let Arr = [".jpg", ".png", ".mp4", ".mov",".jpeg",".avc",".heic",".hevc"];
      let fileName = files.name;
      let fileIndex = fileName.lastIndexOf('.');
      let substrName = fileName.substr(fileIndex);
      if (Arr.indexOf(substrName) < 0) {
        this.$message({
          type: "error",
          message: this.$t('onlyIMG'),
        });
        file.target.value = null
        return false;
      }
      chatApi.uploadFile(files);
      setTimeout(() => {
        this.$refs.input_file.value = '';
        file.target.value = null
      }, 400)
      return false
    },
    onUploadImg(file) {
      const files = file.target.files[0]; //获取文件
      chatApi.uploadImg(files);
    },
    // 选择表情
    chooseEmoji(event) {
      this.$emit("chooseEmojiFn", event.target.innerHTML);
      this.$store.dispatch("setConfigH5", [
        { key: "showModal", value: false },
        {
          key: "showMenus",
          value: false,
        },
        { key: "showEmoji", value: false },
      ]);
    },
  },
};
</script>
<style scoped>
.menus {
  display: flex;
  font-size: 0;
}

div.menu_li {
  display: inline-block;
  width: 60px;
  flex: 1;
  height: 78px;
  margin: 20px 15px;
  position: relative;
}

div.menu_li input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.menu_icon {
  width: 60px;
  height: 60px;
  display: inline-block;
  background: #ffffff;
}

.menu_icon span {
  display: inline-block;
  /*background-size: 100% 100%;*/
  background-size: 296px 79px;
  background-image: url("../../../static/image/H5_ui.png");
}

.menu_title {
  font-size: 14px;
  color: #666;
  display: inline-block;
  width: 100%;
  text-align: center;
  letter-spacing: 1.75px;
  margin: 5px 0;
}

.menu_icon .message {
  /*background-image: url("../../../static/image/email.png");*/
  width: 30px;
  height: 32px;
  margin: 13px auto;
  position: relative;
  background-position: -298px 0;
  background-size: 298px 87px;
}

.file {
  width: 28px;
  height: 28px;
  margin: 16px auto;
  background-position: -385px -2px;
}

.camera {
  background-position: -354px 0;

  width: 32px;
  height: 31px;
  margin: 13px auto;
}

.evaluate {
  background-position: -325px 0;
  width: 29px;
  height: 29px;
  margin: 14px auto;
}

.emoji {
  height: 200px;
  overflow-y: scroll;
}

.emoji>span {
  width: 47px;
  display: inline-block;
  height: 47px;
  cursor: pointer;
  font-size: 31px;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/footMenu.vue